import React from 'react';
import { useGenGridCol } from '../../../../../utils/ComponentHelper';
import { displayAmountCurrying } from '../../../../../utils';
import { useTranslation } from '../../../../../hooks';
import {
  ExactGetExecutionDetail,
  ExecutionType,
  Operation,
} from '../types/OperationDetailsRequestBody';
import { getSwapPathDisplay } from '../utils/getSwapPathDisplay';
import { TransactionOperation } from '../../types/GetListRes';

interface IProps {
  transactionOperations: TransactionOperation[];
}

type ExactGetExecutionDetailsWithMeta = ExactGetExecutionDetail & {
  operation_seq?: string;
  batch_id?: string;
};

const useSwapDetailsExactGetTable = ({ transactionOperations }: IProps) => {
  const { translate } = useTranslation();

  // Exact Get
  const exactGetColumns = [
    // useGenGridCol('operationSequence', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('batchId', {
    //   minWidth: 140,
    // }),
    // useGenGridCol('toAddress', {
    //   minWidth: 350,
    // }),
    useGenGridCol('executionType', {
      minWidth: 250,
    }),
    useGenGridCol('exactGetAmount', {
      minWidth: 140,
    }),
    useGenGridCol('maxPayAmount', {
      minWidth: 140,
    }),

    useGenGridCol('swapPath', {
      minWidth: 250,
    }),
  ];

  const createExecutionDetailsArray = (transactionOperations: TransactionOperation[]) => {
    const executionDetails = transactionOperations.map((operation) => {
      return {
        operation_seq: operation?.operationSeq,
        batch_id: operation?.batchId,
        ...JSON.parse(operation?.executionDetail || '{}'),
      };
    });

    return executionDetails as ExactGetExecutionDetailsWithMeta[];
  };

  const executionDetails = createExecutionDetailsArray(transactionOperations);

  const exactGetRows = executionDetails
    ?.map((executionDetail: ExactGetExecutionDetailsWithMeta, index: number) => {
      const toMaxPayDisplayAmount = displayAmountCurrying(executionDetail?.decimals_pay || '');
      const toExactGetDisplayAmount = displayAmountCurrying(executionDetail?.decimals || '');

      const swapPathDisplay = getSwapPathDisplay(executionDetail?.swap_path || []);

      return {
        id: index,
        operationSequence: executionDetail?.operation_seq || '',
        batchId: executionDetail?.batch_id || '',
        maxPayAmount: `${toMaxPayDisplayAmount(executionDetail?.amount_pay_max || '')} ${
          executionDetail?.asset_name_pay || ''
        }`,
        exactGetAmount: `${toExactGetDisplayAmount(executionDetail?.amount || '')} ${
          executionDetail?.asset_name || ''
        }`,
        toAddress: executionDetail?.to_address || '',
        executionType:
          translate(`enumConstants.${ExecutionType[executionDetail?.execution_type]}`) || '',
        swapPath: swapPathDisplay,
      };
    })
    ?.sort((a, b) => {
      // sort by operation sequence in ascending order
      const operationSeqA = Number(a.operationSequence);
      const operationSeqB = Number(b.operationSequence);

      return operationSeqA - operationSeqB;
    });

  return { exactGetColumns, exactGetRows };
};

export default useSwapDetailsExactGetTable;
